import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { nl } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// value & onChange gebruiken ISO-datum (yyyy-MM-dd); weergave is Nederlands (dd-mm-jjjj)
export function DateField({ value, onChange, placeholder = "dd-mm-jjjj", testId, min, className, disabled }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const minDate = min ? parse(min, "yyyy-MM-dd", new Date()) : undefined;
  const label = selected && isValid(selected) ? format(selected, "dd-MM-yyyy", { locale: nl }) : "";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} data-testid={testId}
          className={`w-full justify-start font-normal ${label ? "" : "text-slate-400"} ${className || ""}`}>
          <CalendarIcon className="h-4 w-4 mr-2 opacity-60 shrink-0" />
          {label || placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={nl}
          selected={selected && isValid(selected) ? selected : undefined}
          defaultMonth={selected && isValid(selected) ? selected : undefined}
          disabled={minDate ? { before: minDate } : undefined}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
